"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compositionLocked = exports.compositionLockedByFailedSave = exports.compositionLockedByUserInAnotherSession = exports.compositionLockedByAnotherUser = void 0;

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var compositionLockedByAnotherUser = (0, _memoize.default)(function (lock, auth) {
  var currentUser = auth.user.get('user_id');
  var lockedBy = lock.lockedBy,
      lockedUntil = lock.lockedUntil;
  var now = new Date().valueOf();
  return lockedUntil > now && lockedBy !== currentUser;
}, function (lock) {
  return lock.hashCode();
});
exports.compositionLockedByAnotherUser = compositionLockedByAnotherUser;
var compositionLockedByUserInAnotherSession = (0, _memoize.default)(function (lock, auth) {
  var session = auth.session,
      user = auth.user;
  var currentUser = user.get('user_id');
  var lockedBy = lock.lockedBy,
      lockedSession = lock.lockedSession,
      lockedUntil = lock.lockedUntil;
  var now = new Date().valueOf();
  return lockedSession && lockedUntil > now && lockedBy === currentUser && lockedSession !== session;
}, function (lock) {
  return lock.hashCode();
});
exports.compositionLockedByUserInAnotherSession = compositionLockedByUserInAnotherSession;
var compositionLockedByFailedSave = (0, _memoize.default)(function (saveState) {
  return saveState.saveFailed;
}, function (saveState) {
  return saveState.hashCode();
});
exports.compositionLockedByFailedSave = compositionLockedByFailedSave;

var compositionLocked = function compositionLocked(lock, auth, saveState) {
  return compositionLockedByFailedSave(saveState) || compositionLockedByAnotherUser(lock, auth) || compositionLockedByUserInAnotherSession(lock, auth) || false;
};

exports.compositionLocked = compositionLocked;